import { SxProps, Theme } from '@mui/material';

/**
 * Shared styles for compact tables used across internal pages
 */
export const compactTableStyles = {
  table: {
    size: 'small' as const,
  },
  tableHead: {
    '& .MuiTableCell-head': {
      fontSize: '0.75rem',
      py: 1,
      fontWeight: 600,
      backgroundColor: 'grey.50',
    },
  } as SxProps<Theme>,
  tableBody: {
    '& .MuiTableCell-body': {
      fontSize: '0.75rem',
      py: 0.5,
    },
    '& .MuiTableRow-root': {
      '&:hover': {
        backgroundColor: 'action.hover',
      },
    },
  } as SxProps<Theme>,
  chip: {
    fontWeight: 'medium',
    fontSize: '0.7rem',
    height: '20px',
  } as SxProps<Theme>,
  iconButton: {
    padding: '4px',
  } as SxProps<Theme>,
};

/**
 * Shared styles for monospace/code display
 */
export const codeStyles = {
  small: {
    fontFamily: 'monospace',
    fontSize: '0.85em',
  } as SxProps<Theme>,
  inline: {
    fontFamily: 'monospace',
    fontSize: '0.85em',
    backgroundColor: 'grey.100',
    padding: '2px 4px',
    borderRadius: '3px',
  } as SxProps<Theme>,
};